export const GET_TEXT_LIST_BY_ID_M = (id, preview: boolean) => `
  query {
    textList(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
    listStyle
    texts
    }
  }
`;
